import styled from 'styled-components'

import { PreviewContent as BasePreviewContent } from '../previewStyles'

export { Container } from '../previewStyles'

export const PreviewContent = styled(BasePreviewContent)`
  background-color: ${props => props.theme.colors.background.secondary};
`

export const DialogCard = styled.div`
  padding: ${props => props.theme.spacing.sp32};
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.primitives.radius.radius4};
  box-shadow: ${props => props.theme.elevation.elevation3};
`

export const DialogTitle = styled.div`
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  padding-bottom: ${props => props.theme.spacing.sp8};
  margin-bottom: ${props => props.theme.spacing.sp24};
`

export const DialogMessage = styled.div`
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  line-height: ${props => props.theme.texts.bodyMRegular.lineHeight};
  color: ${props => props.theme.colors.accent.on};

  p {
    margin: 0;
  }
`

export const DialogActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-top: ${props => props.theme.spacing.sp24};
`
